// Mirror of Shared/Calculators/InsulationCalculator.cs.
import type { CalcDef, ResultLine } from "../types.js";
import * as F from "../format.js";

const fields: CalcDef["fields"] = [
  { key: "areaLengthFt", kind: "number", default: 20, min: 1, max: 300 },
  { key: "areaWidthFt", kind: "number", default: 20, min: 1, max: 300 },
  {
    key: "rValue",
    kind: "select",
    defaultChoice: "r30",
    choices: [
      { value: "r13", set: { bagCoverageSqft: 106 } },
      { value: "r19", set: { bagCoverageSqft: 75 } },
      { value: "r30", set: { bagCoverageSqft: 58 } },
      { value: "r38", set: { bagCoverageSqft: 49 } },
      { value: "r49", set: { bagCoverageSqft: 42 } },
    ],
  },
  { key: "wastePct", kind: "number", default: 5, min: 0, max: 20 },
  { key: "pricePerBag", kind: "number", default: 45, min: 0, max: 200 },
];

function compute(i: Record<string, number>): Record<string, number> {
  const l = F.get(i, "areaLengthFt");
  const w = F.get(i, "areaWidthFt");
  const bagCov = F.get(i, "bagCoverageSqft");
  const waste = F.get(i, "wastePct");
  const price = F.get(i, "pricePerBag");

  const area = l * w;
  const withWaste = area * (1 + waste / 100);
  const bags = bagCov > 0 ? F.ceilUnits(withWaste / bagCov) : 0;
  const cost = bags * price;

  return {
    area: F.round(area, 2),
    withWaste: F.round(withWaste, 2),
    bags,
    cost: F.round(cost, 2),
  };
}

function present(_i: Record<string, number>, r: Record<string, number>): ResultLine[] {
  const bags = F.get(r, "bags");
  return [
    { label: "Area", value: `${F.dec(F.get(r, "area"))} sq ft` },
    { label: "Bags to buy", value: `${F.intStr(bags)} ${F.plural(bags, "bag", "bags")}`, highlight: true },
    { label: "Est. materials cost", value: F.usd(F.get(r, "cost")), sub: "rough — insulation only, excludes air-sealing & labor" },
  ];
}

export const insulation: CalcDef = { slug: "insulation-calculator", fields, compute, present };
